import PricingModels from "./pricingModels/PricingModels";
import Templates from "./templates/Templates";
import ConfigSummary from "./userConfig/ConfigSummary";
import NavigationConfigOverlay from "./userConfig/NavigationConfigOverlay";
import NotificationTriggers from "./userConfig/NotificationTriggers";
import StaticDataEditor from "./userConfig/StaticDataEditor";
import UserConfigOverlay from "./userConfig/UserConfigOverlay";
import UserConfigRawEditor from "./userConfig/UserConfigRawEditor";
import AdminDashboard from "components/admin/AdminDashboard";
import DashboardContent from "components/layout/DashboardContent";
import TopNav from "components/layout/TopNav";
import ExposuresConfig from "components/settings/ExposuresConfig";
import IndustryClassConfig from "components/settings/IndustryClassConfig";
import PeopleConfig from "components/settings/PeopleConfig";
import UnderwritersConfig from "components/settings/UnderwritersConfig";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useParams,
} from "react-router-dom";
import {
  setImpersonatedCompany,
  clearImpersonatedCompany,
} from "store/impersonationSlice";

const getTabs = () => [
  {
    title: "Components",
    path: "visibility",
    element: <UserConfigOverlay />,
  },
  {
    title: "Navigation",
    path: "navigation",
    element: <NavigationConfigOverlay />,
  },
  {
    title: "Configuration",
    path: "static-data",
    element: <StaticDataEditor />,
  },
  {
    title: "Overlay",
    path: "overlay",
    element: <UserConfigRawEditor />,
  },
  {
    title: "Industry Classes",
    path: "industry-classes",
    element: <IndustryClassConfig />,
  },
  {
    title: "Exposures",
    path: "exposures",
    element: <ExposuresConfig />,
  },
  {
    title: "Underwriters",
    path: "underwriters",
    element: <UnderwritersConfig />,
  },
  {
    title: "People",
    path: "people",
    element: <PeopleConfig />,
  },
  {
    title: "Templates",
    path: "templates",
    element: <Templates />,
  },
  {
    title: "Pricing Models",
    path: "pricing-models",
    element: <PricingModels />,
  },
  {
    title: "Summary",
    path: "summary",
    element: <ConfigSummary />,
  },
  {
    title: "Notifications",
    path: "notifications",
    element: <NotificationTriggers />,
  },
];

const UserConfig = ({ navigationState, setNavigationState }) => {
  const { companyId } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const TABS = getTabs();
  const pathSegments = location.pathname.split("/");
  const settingsSegment = pathSegments[pathSegments.indexOf("settings") + 1];
  const activeTab = TABS.find((tab) => tab.path === settingsSegment);

  useEffect(() => {
    if (companyId) {
      dispatch(setImpersonatedCompany(companyId));
    } else {
      dispatch(clearImpersonatedCompany());
    }

    return () => {
      dispatch(clearImpersonatedCompany());
    };
  }, [companyId, dispatch]);

  return (
    <>
      <AdminDashboard>
        <TopNav
          tabs={TABS}
          parentPath={"settings"}
          navigationState={navigationState}
          setNavigationState={setNavigationState}
        />
        <DashboardContent isFullWidth={activeTab?.path === "summary"}>
          <Routes>
            {TABS.map(({ element, path }) => (
              <Route key={path} path={`${path}/*`} element={element} />
            ))}
            <Route
              path={"*"}
              element={
                <Navigate
                  to={
                    navigationState?.["settings"] != null &&
                    TABS.some((tab) => tab.path === navigationState["settings"])
                      ? navigationState["settings"]
                      : getTabs()[0].path
                  }
                  replace={true}
                />
              }
            />
          </Routes>
        </DashboardContent>
      </AdminDashboard>
    </>
  );
};

export default UserConfig;
